import React, { useEffect, useState } from "react";
import {

  CModal,
  CModalBody,
} from "@coreui/react";
import { useDispatch } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import placeholderImage from "../../../components/assets/image/placeholder.png";
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { addAdminRequest } from "../redux/adminDispatcher";
import { hideAddAdminModal, showAddAdminModal } from "../redux/adminModalDispatcher";
import { imageBaseUrls } from "../../../constant/ApiUrls";
import Select from "react-select";
import { accessList } from "../../../constant/Constants";
const AddAdmin = ({
  buttonLabel = "Add Admin",
  editMode = false,
  adminData = {},
}) => {
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false); // Local State

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [image, setImage] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {

    if (editMode && adminData) {
             console.log("adminData::::::", adminData);
      setName(adminData.name || "");
      setEmail(adminData.email || "");
      var access = adminData.access.split(',');
      var s = [];
      for(let i=0;i<accessList.length;i++){
        if(access.includes(accessList[i].value)){
          s.push(accessList[i]);
        }
      }
      setSelectedOptions(s);

   
      if (adminData.image) {
        setImage(imageBaseUrls(adminData.image));
      }

    }
  }, [editMode, adminData]);

  const resetForm = () => {
    setName("");
    setEmail("");
    setSelectedOptions([]);
    setPassword("");
    setImage(null);
    setUploadImage(null);
  };

  // Handle Image Upload
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (validTypes.includes(file.type)) {
        const imageUrl = URL.createObjectURL(file);
        setImage(imageUrl);
        setUploadImage(file);
      } else {
        alert("Please select a valid image file (JPEG, PNG, JPG)");
      }
    }
  };

  // Handle Add Admin Submission
  const handleAddAdmin = () => {

    if (name.trim() === "") {
      alert("Admin name is required");
      return;
    }


    if (email.trim() === "") {
      alert("Admin email is required");
      return;
    }


    if (!editMode) {
      if (password.trim() === "") {
        alert("Admin password is required");
        return;
      }
    }
    const accessString = selectedOptions.map(item => item.value).join(",");
    console.log('acess', accessString);
    var data = {

      "name": name,
      "email": email,
      "access": accessString
      
    };

    if (!editMode) {
      data['password'] = password;
    }


    if (editMode) {
      data['id'] = adminData.id;
    }


    if (image) {
      data.image = uploadImage;
    }


    dispatch(addAdminRequest(data));
    setName("");
    setEmail("");
    setPassword(null);
    setIsModalVisible(false);
    setUploadImage(null);
    dispatch(hideAddAdminModal());
  };

  return (
    <div>
      {/* Button to Open Modal */}
      <button
        onClick={() => {
          if (!editMode) {
            resetForm(); // Reset the form if adding
          }
          setIsModalVisible(true)
          dispatch(showAddAdminModal())

        }}
        style={{
          backgroundColor: editMode === true ? "#1b87f4" : "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: editMode === true ? "10px" : "14px",
          minWidth: "60px",
          height: editMode === true ? "24px" : "30px",  // Increased height
          padding: editMode === true ? "2px 5px" : "4px 10px", // Added padding
          display: "flex",
          alignItems: "center",
          // alignSelf:"end",
          justifyContent: "center",
        }}
      >{buttonLabel}</button>

      {/* Modal */}
      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        className="attributemodal"

      >
        <CModalBody className="main-container createAdmin" >
          <div className="main-container createAdmin">
            {/* Close Button */}
            <div className="cross-btn-div d-flex">
              <img
                onClick={() => setIsModalVisible(false)}
                src={crossButton}
                alt="close"
                className="cross-button"
              />
            </div>

            <form onSubmit={(e) => e.preventDefault()} className="login-form">
              <div className="mb-4">
                <h4
                  className="h4 fw-bold"
                  style={{ color: "#007bff", textAlign: "center" }}
                >
                  <b>{editMode === true ? "Edit Admin" : "Add Admin"}</b>
                </h4>
              </div>

              {/* Image Upload Section */}
              <div className="mb-3 input-login-box">
                <div className="form-row d-flex justify-content-center mt-2">
                  <input
                    type="file"
                    accept="image/*"
                    id="adminImageUpload"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  <img
                    style={{ height: "120px", width: "120px", borderRadius: "10px", objectFit: "cover" }}
                    onClick={() =>
                      document.getElementById("adminImageUpload").click()
                    }
                    src={image || placeholderImage}
                    alt="Admin Profile Preview"

                  />
                </div>
              </div>

              {/*  Name Input */}
              <div className="mb-3 input-login-box">
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  name="name"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter admin name"
                />
              </div>

              <div className="mb-3 input-login-box">
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  name="email"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter admin email"
                />
              </div>

              {!editMode && <div className="mb-3 input-login-box">
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  name="password"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter admin password"
                />
              </div>}

                <div className="mb-3 input-login-box">
                <Select
                      options={accessList}
                     isMulti={true}
                      value={selectedOptions}
                      onChange={setSelectedOptions}
                      placeholder="User Access"
                    />
              </div>
              {/* Submit Button */}
              <button
                className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                type="button"
                onClick={handleAddAdmin}
              >
                {editMode ? "Update" : "Submit"}
              </button>
            </form>
          </div>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddAdmin;
